<template>
  <component
    :is="componentLoader"
    :show.sync="show"
    :wd.sync="wd"
    :labelPosition="labelPosition"
    :prms.sync="prms"
    :disablePreEditCheck="disablePreEditCheck"
    @on-task-posted="taskPosted"
    @on-edit-close="editClose"
    @on-attach="$emit('on-attach', $event)"
  ></component>
</template>

<script>
export default {
  name: "taskEditLoader",
  props: {
    otCompName: {
      type: String,
      default: () => null
    },
    show: {
      type: Boolean,
      default: () => false
    },
    wd: {
      type: String,
      default: () => "95%"
    },
    prms: {
      type: Object,
      default: () => {}
    },
    disablePreEditCheck: {
      type: Boolean,
      default: () => false
    },
    labelPosition:{
      type: String,
      default: () => "left",
    }
  },
  mounted() {
    if (this.$props.otCompName) {
      this.loadComponent();
    }
  },
  computed: {
    componentLoader() {
      return () => import(`@/components/task/edit/${this.otCompName}`);
    }
  },
  methods: {
    loadComponent() {
      //this.componentLoader().then(comp => {});
      this.componentLoader().then(() => {});
    },
    taskPosted(e) {
      this.$emit("on-task-posted", e);
    },
    editClose() {
      this.$emit("on-edit-close");
    }
    // isTaskChanged() {
    //   if (typeof this.$refs.editComp.isTaskChanged === "function") {
    //     return this.$refs.editComp.isTaskChanged();
    //   }
    // },
    // saveData() {
    //   return this.$refs.editComp.saveData();
    // }
  }
};
</script>
